import { db } from "@/repositories/database";
import type { DRPlanAnalysis } from "@/types";

/**
 * Persistance locale de l'analyse du plan — un enregistrement au plus par
 * dessin (clé `drawingId`). Pas de sync serveur : l'analyse est un état de
 * travail local, les validations créent de vraies FieldObservations.
 */
class PlanAnalysisRepository {
  getByDrawingId(drawingId: number): Promise<DRPlanAnalysis | undefined> {
    return db.planAnalyses.get(drawingId);
  }

  replace(analysis: DRPlanAnalysis): Promise<number> {
    // Le store Pinia fournit des proxys réactifs Vue, que le clonage structuré
    // d'IndexedDB refuse (DataCloneError). Le payload étant 100 % JSON par
    // conception, l'aller-retour JSON garantit des objets purs clonables.
    return db.planAnalyses.put(JSON.parse(JSON.stringify(analysis)));
  }

  deleteByDrawingId(drawingId: number): Promise<void> {
    return db.planAnalyses.delete(drawingId);
  }
}

export const planAnalysisRepository = new PlanAnalysisRepository();
